<!-- Begin Page Content -->
<div class="container-fluid">
    <!-- Page Heading -->
    
    <!-- DataTales Example -->
    <div class="card bg-white shadow mb-4 mt-2">
      <!-- <div class="card-header bg-white py-3">
        <h1 class="text-gray-800"  style="display: inline-block">Manage Users</h1>
        <button type="button" class="btn custom-buttons-btn" style="float: right" [routerLink]="['/component','user','user-add']">Add Users</button>
      </div> -->
      <div class="card-body">
        <div class="table-responsive">
          <table
            datatable
            [dtOptions]="dtoptions"
            class="table table-bordered"
            width="100%"
            *ngIf="users && users.length > 0"
          >
          <!-- <table
            class="table table-bordered"
            width="100%"
            *ngIf="users && users.length > 0"
          > -->
            <thead>
              <tr>
              
                <th>Name </th>
                <th>Email </th>
                <th>Username </th>
                <th></th>

              
              </tr>
            </thead>
            <!-- <tfoot>
              <tr>
               
                <th>FirstName </th>
                <th>LastName </th>
                <th>Email </th>
                <th>RoleName </th>
                <th>UserName </th>
             
                <th></th>
              </tr>
            </tfoot> -->
            <tbody>
              <tr *ngFor="let user of users">
               
                <td>{{ user.FirstName }} </td>
                <td>{{ user.Email }} </td>
                <td> {{ user.UserName }} </td>
              
                <td>
                  
                  <button
                    type="button"
                    class="btn custom-buttons-btn"
                    (click)="navigate(user.UserId)">
                    Edit
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <p *ngIf="!users || users.length <= 0">No users Found !</p>
        </div>
      </div>
    </div>
  </div>
  <!-- /.container-fluid -->
  